import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import Seo from "../components/Seo";

const faqs = [
  {
    q: "What material do you use?",
    a: "Most of our layered signs and decor are made from laser-cut basswood because it cuts cleanly, layers well, and works great for painted and stained custom pieces.",
  },
  {
    q: "Can I request a different material?",
    a: "Basswood is our standard material. Special materials may be considered depending on the project, but they may affect price, availability, and timeline.",
  },
  {
    q: "Can you make logos?",
    a: "Yes, but logos often need design cleanup before they can be laser-cut. Upload your logo and we'll review it.",
  },
  {
    q: "Can you make something from a picture?",
    a: "Sometimes. Photos and detailed images usually need to be simplified or redesigned into laser-friendly artwork.",
  },
  {
    q: "Do I get to approve the design?",
    a: "For custom pieces, we can provide a preview or design direction before production depending on the project.",
  },
  {
    q: "Can you make outdoor signs?",
    a: "Some pieces can be made for outdoor use with the right finish, but weather exposure should be discussed before ordering.",
  },
  {
    q: "How many layers can a sign have?",
    a: "Many of our designs use layered basswood for a raised 3D look. The number of layers depends on the design, size, and structure.",
  },
  {
    q: "What sizes do you offer?",
    a: "Most round signs are made in an 11.5 inch standard size. Larger custom sizes may be available by request depending on the design.",
  },
  {
    q: "How long does a custom piece take?",
    a: "Timing depends on the project, finish work, and current queue. Let us know if you have a deadline and we'll tell you what is realistic before production begins.",
  },
];

export default function FAQ() {
  return (
    <div className="faq-workshop min-h-screen" data-testid="faq-page">
      <Seo
        title="Frequently Asked Questions"
        description="Find answers about custom orders, personalization, production, payments, shipping, pickup, and Beyond Board Woodworking products."
        path="/faq"
      />
      <section className="max-w-3xl mx-auto px-6 lg:px-10 pt-20 pb-16">
        <p className="text-xs uppercase tracking-[0.28em] text-[#D8A34B] mb-3">FAQ</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#F5F0E6] leading-tight">Common questions</h1>
        <p className="mt-6 text-[#B8B7B2] leading-relaxed">
          Anything we missed? Drop us a note on the contact page — we usually
          reply within a day.
        </p>

        <Accordion type="single" collapsible className="mt-12 space-y-3" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="faq-natural-card rounded-2xl"
            >
              <AccordionTrigger className="font-display text-lg text-[#F5F0E6] hover:text-[#D8A34B] hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#B8B7B2] leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
}
